import React from 'react';

interface IconDragHandleProps {
    iconClasses?: string;
}

const IconDragHandle: React.FC<IconDragHandleProps> = ({ iconClasses }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-drag-handle ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <circle cx="5" cy="3" r="1.5" />
            <circle cx="11" cy="3" r="1.5" />
            <circle cx="5" cy="8" r="1.5" />
            <circle cx="11" cy="8" r="1.5" />
            <circle cx="5" cy="13" r="1.5" />
            <circle cx="11" cy="13" r="1.5" />
        </svg>
    );
};

export default IconDragHandle;
